function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 719 498",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1244.04,-478.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dark",
    transform: "matrix(1,0,0,1,340.133,100.751)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-746.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1334.66,1305.06C1336.27,1305.74 1347.34,1293.9 1353.1,1289.65C1358.19,1285.9 1363.99,1282.52 1369.2,1279.61C1374.1,1276.87 1379.52,1274.29 1384.33,1272.18C1388.83,1270.21 1393.4,1268.4 1398.09,1266.95C1403,1265.44 1408.44,1263.79 1413.78,1263.1C1419.28,1262.39 1425.47,1262.86 1431.11,1262.69C1436.62,1262.52 1444.1,1263.01 1447.63,1262.07C1449.84,1261.48 1452.33,1260.62 1452.3,1257.05C1452.28,1253.79 1449.93,1254.56 1448.34,1254.23C1445.52,1253.65 1439.71,1253.52 1435.38,1253.54C1430.05,1253.56 1422.67,1253.54 1416.39,1254.37C1409.65,1255.26 1401.82,1256.91 1394.95,1258.88C1388.2,1260.82 1381.6,1263.33 1375.18,1266.2C1368.71,1269.08 1361.4,1272.98 1356.12,1276.21C1351.64,1278.95 1346.6,1281.38 1343.47,1285.6C1339.89,1290.41 1333.06,1304.39 1334.66,1305.06Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,2523.45,1996.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1330.55,1307.35C1331.87,1308.06 1345.1,1294.38 1351.37,1289.87C1356.59,1286.1 1362.63,1283.05 1368.13,1280.27C1373.39,1277.61 1379.34,1275.23 1384.33,1273.18C1388.87,1271.31 1393.4,1269.4 1398.09,1267.95C1403,1266.44 1408.46,1264.95 1413.78,1264.1C1419.28,1263.22 1425.8,1263.02 1431.11,1262.69C1435.95,1262.38 1442.1,1262.68 1445.63,1262.07C1448.04,1261.66 1452.33,1262.62 1452.3,1259.05C1452.28,1255.79 1450.11,1255.7 1448.34,1255.23C1445.52,1254.48 1439.71,1254.52 1435.38,1254.54C1429.72,1254.56 1421.32,1254.33 1414.39,1255.37C1407.32,1256.42 1399.82,1258.75 1392.95,1260.88C1386.24,1262.97 1379.32,1265.64 1373.18,1268.2C1367.38,1270.61 1361.07,1273.31 1356.12,1276.21C1351.59,1278.86 1346.8,1281.54 1343.47,1285.6C1339.21,1290.79 1329.23,1306.63 1330.55,1307.35Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-748.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1294.41,1312.8C1304.86,1314.43 1308.94,1311.95 1316.8,1305.33C1318.59,1303.82 1324.39,1297.97 1328.76,1295.45C1331.35,1293.96 1332.93,1293.44 1335.48,1295.27C1338.14,1297.18 1340.64,1300.27 1338,1303.92C1334.8,1308.35 1330.08,1311.47 1326.29,1315.42C1318.71,1323.31 1315.39,1330.6 1315.7,1342.01C1315.79,1345.14 1317.12,1348.11 1317.87,1351.15C1318.62,1354.17 1321.42,1356.36 1323.81,1358.35C1336.11,1368.56 1347.37,1362.04 1361.63,1365.52C1365.06,1366.35 1368.19,1370.33 1366.24,1373.9C1361.16,1383.16 1346.83,1378.36 1338.01,1380.35C1328.03,1382.61 1320.96,1391.33 1315.68,1399.32C1314.09,1401.73 1314.01,1409.16 1314.02,1409.33C1315.38,1425.19 1327.95,1431.97 1335.52,1444.42C1337.36,1447.44 1336.76,1452.47 1332.85,1453.61C1325.14,1455.86 1319.16,1444.49 1315.93,1441.38C1308.04,1433.81 1300.75,1430.48 1289.34,1430.8C1272.61,1431.26 1265.92,1448.62 1264.52,1462.82C1263.98,1468.17 1264.66,1473.7 1263.39,1478.92C1262.55,1482.36 1258.57,1485.49 1255,1483.53C1247.96,1479.67 1251.78,1467.4 1251.68,1462.92C1251.46,1452.04 1248.67,1444.4 1240.37,1436.64C1229.14,1426.13 1219.23,1429.68 1208.76,1438.81C1204.86,1442.21 1198.63,1452.54 1190.78,1450.52C1187.41,1449.65 1184.79,1445.4 1186.52,1442.85C1189.59,1438.32 1196.36,1431.68 1200.02,1427.62C1209.84,1416.74 1210.6,1408.17 1206.66,1394.12C1205.82,1391.13 1202.96,1389.02 1200.51,1387.11C1187.9,1377.28 1174.57,1381.76 1160.21,1378.73C1156.75,1378 1153.5,1374.12 1155.35,1370.49C1160.13,1361.08 1176.89,1367.82 1185.64,1365.56C1195.54,1362.99 1202.34,1354.06 1207.37,1345.91C1208.89,1343.46 1208.75,1336.02 1208.73,1335.86C1206.88,1320.04 1194.11,1313.65 1186.16,1301.43C1184.24,1298.47 1184.68,1293.43 1188.55,1292.17C1196.18,1289.68 1202.51,1300.87 1205.84,1303.88C1213.96,1311.2 1221.35,1314.3 1232.74,1313.64C1235.96,1313.45 1239.63,1313.15 1242.06,1311.02C1251.74,1302.52 1255.69,1293.7 1256.57,1280.87C1256.92,1275.71 1254.03,1264 1261.01,1259.88C1264.01,1258.11 1268.46,1260.94 1269.04,1263.96C1270.95,1273.89 1267.95,1280.79 1270.38,1290.17C1273.01,1300.34 1283.91,1311.16 1294.41,1312.8Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-10,-748.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.831491,0,249.972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M984.2,1467.55C986.796,1469.63 991.987,1473.8 994.932,1475.75C997.092,1477.18 999.364,1478.6 1001.87,1479.27C1004.58,1480.01 1008.09,1480.02 1011.22,1480.15C1017.06,1480.41 1031.62,1480.49 1036.87,1480.81C1038.85,1480.92 1041.68,1480.96 1042.7,1482.03C1043.73,1483.09 1043.73,1486 1043.03,1487.2C1042.34,1488.39 1040.16,1489.02 1038.52,1489.19C1033.2,1489.74 1016.98,1490.15 1011.11,1490.5C1008.5,1490.65 1005.84,1490.66 1003.3,1491.27C1000.64,1491.91 997.592,1493.01 995.152,1494.35C992.765,1495.66 990.027,1498.09 988.658,1499.31",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.53px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01348,-1.06828e-16,1.06041e-16,1.00602,-12.9845,-12.5388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 972.229,
    cy: 1489.37,
    r: 23.308,
    style: {
      fill: "rgb(37,55,77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.229,1466.06C985.093,1466.06 995.537,1476.51 995.537,1489.37C995.537,1502.24 985.093,1512.68 972.229,1512.68C959.365,1512.68 948.921,1502.24 948.921,1489.37C948.921,1476.51 959.365,1466.06 972.229,1466.06ZM972.229,1474.35C980.538,1474.35 987.315,1481.06 987.315,1489.37C987.315,1497.68 980.538,1504.4 972.229,1504.4C963.92,1504.4 957.144,1497.68 957.144,1489.37C957.144,1481.06 963.92,1474.35 972.229,1474.35Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,-1,1,6.12323e-17,-328.872,1807.01)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01348,-1.06828e-16,1.06041e-16,1.00602,-13.9845,-12.5388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 972.229,
    cy: 1489.37,
    r: 23.308,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.13px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,2555.11,328.872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1140.63,1568.64C1142.79,1565.99 1147.11,1560.69 1148.94,1557.84C1150.17,1555.91 1151.37,1553.8 1151.59,1551.53C1152.05,1546.68 1151.59,1534.71 1151.7,1528.76C1151.77,1524.43 1151.78,1520.06 1152.2,1515.8C1152.63,1511.55 1153.13,1507.28 1154.25,1503.16C1155.9,1497.05 1160.21,1484.29 1162.13,1479.18C1163.01,1476.81 1162.8,1475.43 1165.71,1472.5C1166.7,1471.51 1167.64,1469.98 1168.73,1468.84C1174,1463.35 1191.55,1443.83 1197.31,1439.59C1199.2,1438.19 1202.89,1441.91 1203.28,1443.36C1203.66,1444.81 1200.94,1446.72 1199.62,1448.27C1197.02,1451.29 1191.39,1457.34 1187.72,1461.48C1184.3,1465.33 1180.43,1469.53 1177.58,1473.12C1175.07,1476.27 1172.46,1479.41 1170.61,1483C1168.43,1487.2 1166.15,1493.26 1164.52,1498.38C1162.92,1503.39 1161.58,1509.78 1160.8,1513.71C1160.26,1516.43 1159.94,1519.21 1159.82,1521.99C1159.57,1527.32 1159.28,1540.7 1159.33,1545.66C1159.36,1547.71 1159.34,1549.86 1160.12,1551.75C1161.01,1553.87 1162.99,1556.29 1164.63,1558.4C1166.82,1561.21 1171.11,1566.14 1173.26,1568.6",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.17px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,2851.18,-559.888)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01348,-1.06828e-16,1.06041e-16,1.00602,-13.9845,-12.5388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 972.229,
    cy: 1489.37,
    r: 23.308,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.13px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,2555.11,328.872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1139.63,1569.64C1142.07,1566.99 1146.94,1561.69 1148.94,1558.84C1150.24,1556.97 1151.37,1554.8 1151.59,1552.53C1152.05,1547.68 1151.59,1535.71 1151.7,1529.76C1151.77,1525.43 1151.89,1521.11 1152.2,1516.8C1152.54,1512.2 1152.84,1507.01 1153.73,1502.19C1154.9,1495.91 1157.81,1484.59 1159.2,1479.12C1160.04,1475.83 1160.88,1471.57 1162.11,1469.35C1163.03,1467.68 1165.2,1467.11 1166.58,1465.8C1172.43,1460.21 1191.1,1440.21 1197.19,1435.84C1199.11,1434.47 1203.66,1437.66 1203.17,1439.62C1202.68,1441.57 1197.04,1445.1 1194.26,1447.57C1191.69,1449.85 1188.9,1451.91 1186.5,1454.38C1183.23,1457.76 1177.91,1463.13 1174.65,1467.79C1171.5,1472.28 1168.85,1478.05 1166.94,1482.32C1165.34,1485.88 1164.04,1489.6 1163.16,1493.4C1162.03,1498.28 1160.72,1506.73 1160.17,1511.57C1159.76,1515.16 1159.94,1518.8 1159.86,1522.42C1159.72,1528.27 1159.29,1541.61 1159.33,1546.66C1159.35,1548.71 1159.22,1550.92 1160.12,1552.75C1161.17,1554.87 1163.78,1557.19 1165.63,1559.4C1167.99,1562.21 1172.16,1567.14 1174.26,1569.6",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.17px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-44.8214,-859.893)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.831491,0,249.972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M984.2,1467.55C986.796,1469.63 991.987,1473.8 994.932,1475.75C997.092,1477.18 999.364,1478.6 1001.87,1479.27C1004.58,1480.01 1008.09,1480.02 1011.22,1480.15C1017.06,1480.41 1031.62,1480.49 1036.87,1480.81C1038.85,1480.92 1041.68,1480.96 1042.7,1482.03C1043.73,1483.09 1043.73,1486 1043.03,1487.2C1042.34,1488.39 1040.16,1489.02 1038.52,1489.19C1033.2,1489.74 1016.98,1490.15 1011.11,1490.5C1008.5,1490.65 1005.84,1490.66 1003.3,1491.27C1000.64,1491.91 997.592,1493.01 995.152,1494.35C992.765,1495.66 990.027,1498.09 988.658,1499.31",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.53px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01348,-1.06828e-16,1.06041e-16,1.00602,-12.9845,-13.5388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 972.229,
    cy: 1489.37,
    r: 23.308,
    style: {
      fill: "rgb(37,55,77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.229,1466.06C985.093,1466.06 995.537,1476.51 995.537,1489.37C995.537,1502.24 985.093,1512.68 972.229,1512.68C959.365,1512.68 948.921,1502.24 948.921,1489.37C948.921,1476.51 959.365,1466.06 972.229,1466.06ZM972.229,1474.35C980.538,1474.35 987.315,1481.06 987.315,1489.37C987.315,1497.68 980.538,1504.4 972.229,1504.4C963.92,1504.4 957.144,1497.68 957.144,1489.37C957.144,1481.06 963.92,1474.35 972.229,1474.35Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,2561.24,-859.893)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.831491,-10,249.972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M984.2,1467.55C986.796,1469.63 991.987,1473.8 994.932,1475.75C997.092,1477.18 999.364,1478.6 1001.87,1479.27C1004.58,1480.01 1008.09,1480.02 1011.22,1480.15C1017.06,1480.41 1031.62,1480.49 1036.87,1480.81C1038.85,1480.92 1041.68,1480.96 1042.7,1482.03C1043.73,1483.09 1043.73,1486 1043.03,1487.2C1042.34,1488.39 1040.16,1489.02 1038.52,1489.19C1033.2,1489.74 1016.98,1490.15 1011.11,1490.5C1008.5,1490.65 1005.84,1490.66 1003.3,1491.27C1000.64,1491.91 997.592,1493.01 995.152,1494.35C992.765,1495.66 990.027,1498.09 988.658,1499.31",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.53px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01348,1.06828e-16,-1.06041e-16,1.00602,-22.9845,-12.5388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 972.229,
    cy: 1489.37,
    r: 23.308,
    style: {
      fill: "rgb(37,55,77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.229,1466.06C985.093,1466.06 995.537,1476.51 995.537,1489.37C995.537,1502.24 985.093,1512.68 972.229,1512.68C959.365,1512.68 948.921,1502.24 948.921,1489.37C948.921,1476.51 959.365,1466.06 972.229,1466.06ZM972.229,1474.35C963.92,1474.35 957.144,1481.06 957.144,1489.37C957.144,1497.68 963.92,1504.4 972.229,1504.4C980.538,1504.4 987.315,1497.68 987.315,1489.37C987.315,1481.06 980.538,1474.35 972.229,1474.35Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,2527.28,-972.492)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.831491,0,249.972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M984.2,1467.55C986.796,1469.63 991.987,1473.8 994.932,1475.75C997.092,1477.18 999.364,1478.6 1001.87,1479.27C1004.58,1480.01 1008.09,1480.02 1011.22,1480.15C1017.06,1480.41 1031.62,1480.49 1036.87,1480.81C1038.85,1480.92 1041.68,1480.96 1042.7,1482.03C1043.73,1483.09 1043.73,1486 1043.03,1487.2C1042.34,1488.39 1040.16,1489.02 1038.52,1489.19C1033.2,1489.74 1016.98,1490.15 1011.11,1490.5C1008.5,1490.65 1005.84,1490.66 1003.3,1491.27C1000.64,1491.91 997.592,1493.01 995.152,1494.35C992.765,1495.66 990.027,1498.09 988.658,1499.31",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.53px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01348,1.06828e-16,-1.06041e-16,1.00602,-12.9845,-12.5388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 972.229,
    cy: 1489.37,
    r: 23.308,
    style: {
      fill: "rgb(37,55,77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.229,1466.06C985.093,1466.06 995.537,1476.51 995.537,1489.37C995.537,1502.24 985.093,1512.68 972.229,1512.68C959.365,1512.68 948.921,1502.24 948.921,1489.37C948.921,1476.51 959.365,1466.06 972.229,1466.06ZM972.229,1474.35C963.92,1474.35 957.144,1481.06 957.144,1489.37C957.144,1497.68 963.92,1504.4 972.229,1504.4C980.538,1504.4 987.315,1497.68 987.315,1489.37C987.315,1481.06 980.538,1474.35 972.229,1474.35Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.749567,0.661928,-0.661928,0.749567,1258.03,-1231.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-1.50904e-16,0,0.735206,-1.13687e-13,393.182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M984.2,1467.55C986.588,1469.88 991.363,1474.55 994.182,1476.65C996.26,1478.2 998.614,1479.5 1001.12,1480.17C1003.83,1480.91 1007.34,1480.92 1010.47,1481.05C1028.99,1481.84 1092.5,1485.46 1112.19,1484.87C1118.17,1484.69 1128.08,1476.55 1128.57,1477.52C1129.05,1478.5 1118.09,1487.99 1115.09,1490.73C1113.73,1491.97 1112.42,1493.92 1110.58,1493.92C1093.25,1493.88 1028.99,1490.94 1011.11,1490.5C1008.5,1490.44 1005.83,1490.78 1003.3,1491.27C1000.77,1491.76 998.155,1492.22 995.901,1493.45C993.462,1494.79 990.259,1497.8 988.658,1499.31",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.75px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01348,-1.06828e-16,1.06041e-16,1.00602,-13.2349,-13.2007)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 972.229,
    cy: 1489.37,
    r: 23.308,
    style: {
      fill: "rgb(37,55,77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.229,1466.06C985.093,1466.06 995.537,1476.51 995.537,1489.37C995.537,1502.24 985.093,1512.68 972.229,1512.68C959.365,1512.68 948.921,1502.24 948.921,1489.37C948.921,1476.51 959.365,1466.06 972.229,1466.06ZM972.229,1474.35C980.538,1474.35 987.315,1481.06 987.315,1489.37C987.315,1497.68 980.538,1504.4 972.229,1504.4C963.92,1504.4 957.144,1497.68 957.144,1489.37C957.144,1481.06 963.92,1474.35 972.229,1474.35Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.749567,-0.661928,0.661928,-0.749567,1271.46,2483.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M982.701,1468.88C985.297,1470.96 990.488,1475.12 993.433,1477.07C995.593,1478.51 997.864,1479.92 1000.37,1480.6C1003.08,1481.33 1006.59,1481.34 1009.72,1481.48C1027.61,1482.26 1088.34,1485.25 1107.69,1485.31C1113.84,1485.32 1124.68,1480.99 1125.81,1481.81C1126.93,1482.62 1117.08,1488.28 1114.43,1490.21C1112.94,1491.3 1111.76,1493.43 1109.92,1493.41C1092.71,1493.22 1028.96,1489.68 1011.2,1489.09C1008.58,1489 1005.93,1489.25 1003.38,1489.86C1000.73,1490.5 997.68,1491.6 995.24,1492.94C992.853,1494.25 990.114,1496.68 988.745,1497.89",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.17px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01348,-1.06828e-16,1.06041e-16,1.00602,-13.2349,-13.2007)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 972.229,
    cy: 1489.37,
    r: 23.308,
    style: {
      fill: "rgb(37,55,77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.229,1466.06C985.093,1466.06 995.537,1476.51 995.537,1489.37C995.537,1502.24 985.093,1512.68 972.229,1512.68C959.365,1512.68 948.921,1502.24 948.921,1489.37C948.921,1476.51 959.365,1466.06 972.229,1466.06ZM972.229,1474.35C980.538,1474.35 987.315,1481.06 987.315,1489.37C987.315,1497.68 980.538,1504.4 972.229,1504.4C963.92,1504.4 957.144,1497.68 957.144,1489.37C957.144,1481.06 963.92,1474.35 972.229,1474.35Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.64526,-0.763963,0.763963,0.64526,-703.3,633.105)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01348,-1.06828e-16,1.06041e-16,1.00602,-13.9845,-12.5388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 972.229,
    cy: 1489.37,
    r: 23.308,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.13px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M984.2,1467.55C986.796,1469.63 991.987,1473.8 994.932,1475.75C997.092,1477.18 999.364,1478.6 1001.87,1479.27C1004.58,1480.01 1008.1,1479.97 1011.22,1480.15C1031.25,1481.34 1101.25,1485.09 1122.04,1486.37C1126.72,1486.66 1134.98,1486.59 1136.01,1487.86C1137.04,1489.12 1130.26,1492.41 1128.21,1493.96C1126.74,1495.08 1125.54,1497.21 1123.69,1497.16C1104.18,1496.58 1031.18,1491.48 1011.11,1490.5C1008.5,1490.37 1005.84,1490.66 1003.3,1491.27C1000.64,1491.91 997.592,1493.01 995.152,1494.35C992.765,1495.66 990.027,1498.09 988.658,1499.31",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.17px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.629809,0.77675,-0.77675,-0.629809,3226.69,584.406)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01348,-1.06828e-16,1.06041e-16,1.00602,-13.9845,-12.5388)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 972.229,
    cy: 1489.37,
    r: 23.308,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.13px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-6.02537e-17,1.75281e-16,0.864422,-8.40449e-13,201.471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M984.2,1467.55C986.796,1469.63 991.987,1473.8 994.932,1475.75C997.092,1477.18 999.364,1478.6 1001.87,1479.27C1004.58,1480.01 1008.1,1479.9 1011.22,1480.15C1030.2,1481.68 1094.85,1486.51 1115.74,1488.43C1122.74,1489.08 1135.27,1490.32 1136.56,1491.72C1137.85,1493.11 1126.4,1495.41 1123.47,1496.79C1121.8,1497.57 1120.79,1500.08 1118.95,1499.98C1100.23,1498.93 1030.39,1491.95 1011.11,1490.5C1008.5,1490.3 1005.84,1490.66 1003.3,1491.27C1000.64,1491.91 997.592,1493.01 995.152,1494.35C992.765,1495.66 990.027,1498.09 988.658,1499.31",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.46px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.456018,10,-0.683877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1019.29,1368.56C1017.13,1368.72 1014.93,1370.29 1014.89,1373.35C1014.86,1376.87 1016.41,1378.38 1018.5,1378.48C1028.26,1378.94 1052.37,1378.78 1075.83,1378.84C1098.19,1378.9 1119.94,1379.2 1129.3,1378.81C1131.53,1378.72 1133.91,1376.79 1133.58,1373.68C1133.3,1371.05 1131.19,1368.77 1128.9,1368.67C1119.6,1368.25 1098.08,1368.65 1075.94,1368.62C1052.79,1368.59 1029.46,1367.77 1019.29,1368.56Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "5.36px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.637346,367.269,-249.709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1019.29,1368.56C1017.13,1368.72 1014.93,1370.29 1014.89,1373.35C1014.86,1376.87 1016.41,1378.38 1018.5,1378.48C1028.26,1378.94 1052.37,1378.78 1075.83,1378.84C1098.19,1378.9 1119.94,1379.2 1129.3,1378.81C1131.53,1378.72 1133.91,1376.79 1133.58,1373.68C1133.3,1371.05 1131.19,1368.77 1128.9,1368.67C1119.6,1368.25 1098.08,1368.65 1075.94,1368.62C1052.79,1368.59 1029.46,1367.77 1019.29,1368.56Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.97px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2.02533,-749.861)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1260.7,
    cy: 1376.52,
    r: 29.477,
    style: {
      fill: "white",
      stroke: "rgb(37,55,77)",
      strokeWidth: "8.33px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white_logo.04e7d01854c8ae2ef78d8fb523500b20.svg";
export { ForwardRef as ReactComponent };